import * as React from "react";
import { saveAs } from "file-saver";

export const usePreviewViewModel = (props) => {
  const [saved, setSaved] = React.useState(true);
  const [colorAnchorEl, setColorAnchorEl] = React.useState(null);
  const [approved, setApproved] = React.useState(props.image.image.approved);
  const [localImage, setLocalImage] = React.useState(props.image);

  React.useEffect(() => {
    setLocalImage(props.image);
    setApproved(props.image.image.approved);
  }, [props.image]);

  const saveFile = (filePath) => {
    saveAs(filePath, filePath.split("/")[filePath.split("/").length - 1]);
  };

  const handleClose = () => {
    props.setImage(null);
    props.setMeta(false);
  };

  const confirmDiscardUnsavedMeta = () => {
    if (!saved) {
      if (
        !window.confirm(
          "You have unsaved meta data, are you sure you want to leave this image?"
        )
      ) {
        return false;
      }
    }
    return true;
  };

  const navigateImage = (direction) => {
    if (!confirmDiscardUnsavedMeta()) {
      return false;
    }

    var img = Object.assign({}, props.image);
    const nextIdx =
      direction === "next"
        ? props.image.idx + 1 >= props.image.total
          ? 0
          : props.image.idx + 1
        : props.image.idx - 1 < 0
        ? props.image.total - 1
        : props.image.idx - 1;

    img.idx = nextIdx;
    img.image = props.gallery.documents[nextIdx];
    props.setImage(img);
    setLocalImage(img);
    return true;
  };

  const next = () => navigateImage("next");
  const prev = () => navigateImage("prev");

  const handleOpenColorDropdown = (event) => {
    setColorAnchorEl(event.currentTarget);
  };

  const handleCloseColorDropdown = () => {
    setColorAnchorEl(null);
  };

  const handleSaveColor = (color) => {
    setLocalImage((prevImage) => ({
      ...prevImage,
      image: {
        ...prevImage.image,
        color,
      },
    }));

    var gallery = Object.assign({}, props.gallery);
    gallery.documents = gallery.documents.map((g) => {
      if (g._id !== localImage.image._id) {
        return g;
      }
      return {
        ...g,
        color,
      };
    });
    props.setGallery(gallery);

    props.colorSelected(color, [localImage.image._id]);
    handleCloseColorDropdown();
  };

  const syncApprovedInGallery = (status) => {
    const normalizedStatus = status === "reset" ? "" : status;
    var gallery = Object.assign({}, props.gallery);

    gallery.documents = gallery.documents.map((g) => {
      var currentImage = Object.assign({}, g);
      if (g._id === localImage.image._id) {
        currentImage.approved = normalizedStatus;
      }
      return currentImage;
    });

    props.setGallery(gallery);
  };

  const handleToggleApprove = async (action) => {
    var status = await props.toggleApprove(action, localImage.image._id);
    setApproved(status === "reset" ? "" : status);
    syncApprovedInGallery(status);
  };

  const getDownvoteAction = () =>
    approved === true ? false : approved === false ? "reset" : false;

  const handleToggleMeta = () => {
    props.setMeta(!props.meta);
  };

  const handleDeleteImage = () => {
    var temp = Object.assign({}, props.temp);
    temp.confirm = {
      title: "Are you sure?",
      cancel_text: "No",
      text: "Do you want to delete this photo?",
      confirm_text: "Yes",
      callback_color: "error",
      callback: () => {
        props.deletePhoto(localImage.image._id);

        var deleted = props.deleted.slice();
        deleted.push(localImage.image._id);

        props.setDeleted(deleted);
      },
    };
    props.setTemp(temp);
  };

  return {
    classes: props.classes,
    fullWidth: true,
    maxWidth: "xl",
    open: Boolean(localImage?.image),
    imageUrl: localImage.image.data.previewURL,
    localImage,
    saved,
    setSaved,
    approved,
    colorAnchorEl,
    isColorDropdownOpen: Boolean(colorAnchorEl),
    isDeleted: props.deleted?.includes(localImage.image._id),
    isMetaOpen: props.meta,
    isViewerMode: props.viewer,
    isBlockMode: props.block,
    handleClose,
    handleOpenColorDropdown,
    handleCloseColorDropdown,
    handleSaveColor,
    handleToggleApprove,
    handleToggleMeta,
    handleDeleteImage,
    getDownvoteAction,
    onPrev: prev,
    onNext: next,
    saveFile,
    tagSelected: props.tagSelected,
    folderInfo: props.folderInfo,
    colorSelected: props.colorSelected,
    toggleApprove: props.toggleApprove,
  };
};
